// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__grF66","check-text":"styles_check-text__2ynRL"};